/* tslint:disable */
/* eslint-disable */
/**
 * ahoy
 * Worlds next gen CRM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Membership } from './Membership';
import {
    MembershipFromJSON,
    MembershipFromJSONTyped,
    MembershipToJSON,
    MembershipToJSONTyped,
} from './Membership';

/**
 * 
 * @export
 * @interface PaginatedMembershipList
 */
export interface PaginatedMembershipList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedMembershipList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedMembershipList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedMembershipList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<Membership>}
     * @memberof PaginatedMembershipList
     */
    results: Array<Membership>;
}

/**
 * Check if a given object implements the PaginatedMembershipList interface.
 */
export function instanceOfPaginatedMembershipList(value: object): value is PaginatedMembershipList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedMembershipListFromJSON(json: any): PaginatedMembershipList {
    return PaginatedMembershipListFromJSONTyped(json, false);
}

export function PaginatedMembershipListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedMembershipList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(MembershipFromJSON)),
    };
}

  export function PaginatedMembershipListToJSON(json: any): PaginatedMembershipList {
      return PaginatedMembershipListToJSONTyped(json, false);
  }

  export function PaginatedMembershipListToJSONTyped(value?: PaginatedMembershipList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(MembershipToJSON)),
    };
}

